<!-- 面包屑导航 -->
<template>
  <div class="bread-m">
    <el-breadcrumb
      class="bread-list"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item
        v-for="(list, index) in lists"
        :key="index"
        :to="list.path ? { path: list.path } : ''"
      >{{ list.name || '首页' }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'breadcrumb',
  data () {
    return {
      id: ''
    }
  },
  props: {
    lists: {
      type: Array,
      default: () => {
        return [
          {
            path: '/',
            name: '首页'
          }
        ]
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .bread-m {
    /*width: 1400px;*/
    margin: 20px 20px 20px 0px;
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #a7a8b5;
    font-weight: normal;
  }
  .bread-list{
    font-size: 16px;
  }
  /deep/ .el-breadcrumb__inner.is-link{
    font-weight: normal!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue